import CartCount from "./cart-count";

export default CartCount;
